import api from '@/api';
import { API_BASE_URL } from '..';
import { InvoiceTransportRequest } from './invoiceCarrier.types';

const URL = `${API_BASE_URL}/invoices`;

export async function getInvoiceTransport(
  invoiceId: number,
): Promise<InvoiceTransportRequest> {
  const result = (await api.get(
    `${URL}/${invoiceId}/transports`,
    null,
  )) as unknown;

  return result as InvoiceTransportRequest;
}

export async function createInvoiceTransport(
  invoiceId: number,
  obj: InvoiceTransportRequest,
) {
  const result = (await api.post(
    `${URL}/${invoiceId}/transports`,
    obj,
    null,
  )) as unknown;

  return result as InvoiceTransportRequest & { id: number };
}

export async function updateInvoiceTransport(
  invoiceId: number,
  obj: InvoiceTransportRequest,
) {
  const result = (await api.put(
    `${URL}/${invoiceId}/transports`,
    obj,
    null,
  )) as unknown;

  return result as InvoiceTransportRequest & { id: number };
}
